module.exports = __webpack_public_path__ + "static/media/housesTop.65e22fff.jpg";